import { useState } from "react";
import { useAuth } from "../AuthContext";
import AdminBookings from "../components/AdminBookings";
import AdminContentEditor from "../components/AdminContentEditor";
import AdminAvailability from "../components/AdminAvailability";
import AdminUsers from "../components/AdminUsers";
import AdminRewards from "../components/AdminRewards";
import "../css/AdminDashboard.css";

const ALL_TABS = [
  { id: "bookings",      label: "Bookings",     icon: "📋", superAdminOnly: false },
  { id: "content",       label: "Edit Content", icon: "✏️", superAdminOnly: false },
  { id: "availability",  label: "Availability", icon: "🔄", superAdminOnly: false },
  { id: "rewards",       label: "Rewards",      icon: "🎁", superAdminOnly: false },
  { id: "users",         label: "Users",        icon: "👥", superAdminOnly: false },
];

export default function AdminDashboard() {
  const { currentUser, logout, isAdmin, isSuperAdmin, userRole } = useAuth();

  const tabs = ALL_TABS.filter((t) => !t.superAdminOnly || isSuperAdmin);
  const [activeTab, setActiveTab] = useState("bookings");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // If the active tab is now filtered out (e.g. superAdmin just demoted), fall back
  const visibleTab = tabs.find((t) => t.id === activeTab) ? activeTab : tabs[0]?.id;

  const roleLabel = userRole === "superAdmin" ? "Super Admin" : "Admin";

  return (
    <div className="admin-layout">
      {sidebarOpen && (
        <div className="admin-sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <aside className={`admin-sidebar${sidebarOpen ? " sidebar-open" : ""}`}>
        <div className="admin-brand">
          <p className="admin-brand-title">Admin Panel</p>
        </div>

        <nav className="admin-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`admin-nav-btn ${visibleTab === tab.id ? "active" : ""}`}
              onClick={() => { setActiveTab(tab.id); setSidebarOpen(false); }}
            >
              <span className="nav-icon">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <p className="admin-user-email">{currentUser?.email}</p>
          <span className={`role-pill role-${userRole?.toLowerCase()}`} style={{ fontSize: "0.72rem", marginBottom: "8px", display: "inline-block" }}>
            {roleLabel}
          </span>
          <button className="admin-logout-btn" onClick={logout}>
            Sign Out
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <div className="admin-header">
          <button
            className="admin-hamburger"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <span /><span /><span />
          </button>
          <h1 className="admin-page-title">
            {tabs.find((t) => t.id === visibleTab)?.label}
          </h1>
        </div>

        <div className="admin-content">
          {visibleTab === "bookings"     && <AdminBookings />}
          {visibleTab === "content"      && <AdminContentEditor />}
          {visibleTab === "availability" && <AdminAvailability />}
          {visibleTab === "rewards"      && isAdmin && <AdminRewards />}
          {visibleTab === "users"        && isAdmin && <AdminUsers />}
        </div>
      </main>
    </div>
  );
}
